import { render, staticRenderFns } from "./MapDataViewerLegendItem.vue?vue&type=template&id=7ddb2dba&scoped=true&"
import script from "./MapDataViewerLegendItem.vue?vue&type=script&lang=js&"
export * from "./MapDataViewerLegendItem.vue?vue&type=script&lang=js&"
import style0 from "./MapDataViewerLegendItem.vue?vue&type=style&index=0&id=7ddb2dba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddb2dba",
  null
  
)

export default component.exports